import { RELEASE_VERSION, IS_ACTIVE } from './AddReleaseForm.fields';

const FORM_CONFIG = {
  [RELEASE_VERSION.id]: RELEASE_VERSION,
  [IS_ACTIVE.id]: IS_ACTIVE,
};

export default FORM_CONFIG;